import React from 'react';
import Events from '../components/Events';
import Layout from '../components/Layout';
import Partners from '../components/Partners';
import Slideshow from '../components/Slideshow';

const IndexPage = () => (
	<Layout banner>
		<div className='row my-3 my-md-5 justify-content-between align-items-center'>
			<div className='col-md-7 col-lg-5 px-3 order-1'>
				<h1 className='raleway-700 display-3'>Welcome!</h1>
				<p>
					Welcome to the website for ASGSR students! We are a multidisciplinary group of science/engineering
					students across the United States and world who participate (or are just interested in!)
					microgravity sciences. We participate in education, outreach,{/* political advocacy,*/} and professional
					development through the framework of our parent organization, the American Society for Gravitational
					and Space Research.
				</p>
				<p>
					For more information on our parent chapter, see <a href='https://asgsr.org/' target='_blank'>asgsr.org</a>. 
					For more information on ASGSR’s student spaceflight challenge, see the main page for the 
					<a href='https://asgsr.org/souza/' target='_blank'>Ken Souza Memorial Spaceflight Competition</a>.
				</p>
			</div>
			<div className='col-md-5 my-3 order-0 order-md-2'>
				<Slideshow />
			</div>
		</div>

		<div className='row d-flex justify-content-between'>
			<div className='col-md-6'>
				<Events />
			</div>
			<div className='col-md-6'>
				<h3 className='display-7 raleway-700'>Student Awards</h3>
				<div className='d-flex flex-column flex-wrap align-items-stretch h-100'>
					Applications are now open for the ASGSR student awards! We have two opportunities available:
    				<ul>
						<li><a href='https://forms.gle/tVqZazqyczYwkuEE6'>Inspiration Scholarship</a>: $1000 each, 4 winners selected (2 in biological sciences and 
							2 in physical sciences). For high school juniors and seniors in the US. Rec letter from a mentor/teacher/etc is required.
						</li>
						<li><a href='https://forms.gle/7nBep9e227xTsrnd6'>ASGSR Student Awards</a>: <strong>New this year!</strong> $250 each, 8 winners selected. Open to students of 
							any age anywhere in the world, ASGSR student membership is encouraged but not required. There are 3 categories: t-shirt design (1 winner),
							creative challenge with story/art/video (3 winners) and hosting a space-themed event (4 winners). Students may apply to all 3 if interested.
						</li>
					</ul>
					 More info is available at each of the links above. Applications are open until Oct 1, and questions can be sent to wadhwa@mit.edu if any arise. 
				</div>
			</div>
		</div>
		
		<div className='row mx-auto my-md-5 align-items-center justify-content-center'>
			<a className='btn btn-lg btn-outline-dark fw-bold border border-dark border-2'
			   href='https://asgsr.us20.list-manage.com/subscribe?u=295592de8d4d44479539838a5&id=ea7aa995fe'
			   target='_blank'>Subscribe to our newsletter</a>
		</div>
		
		{/*	
		<div className='row my-3 my-md-5 justify-content-between align-items-center'>
			<h2 className='raleway-700 display-7'>Our Partners</h2>
			<Partners />
		</div>
		*/}
	</Layout>
);

export default IndexPage;
